import { render, staticRenderFns } from "./Footer.vue?vue&type=template&id=3d302860&scoped=true&"
import script from "./Footer.vue?vue&type=script&lang=js&"
export * from "./Footer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d302860",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3d302860')) {
      api.createRecord('3d302860', component.options)
    } else {
      api.reload('3d302860', component.options)
    }
    module.hot.accept("./Footer.vue?vue&type=template&id=3d302860&scoped=true&", function () {
      api.rerender('3d302860', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/layout/Footer.vue"
export default component.exports